<template>
    <div>
        <slot name="items"
            v-bind="{items,loading}"
            >
            <slot name="item"
                v-for="(item,index) in items"
                v-bind="{item,index,loading}"
                ><div>{{item}}</div></slot>
        </slot>
        <slot v-if="hasMore"
              name="more"
              v-bind="{loading,on:{click:fetchMore},fetchMore}"
            >
            <div class="text-center py-2">
                <v-btn @click="fetchMore" v-intersect="onIntersect" :loading="loading" color="primary">Load more</v-btn>
            </div>
        </slot>
        <slot v-else
            name="no-more"
              v-bind="{loading}"
            >
            <v-alert type="info" dense outlined>No more items</v-alert>
        </slot>
    </div>
</template>
<script>
export default {
    mounted() {
        this.initQuery();
    },
    props: {
        action:{type:String,default:'',},
        method:{type:String,default:'get'},
        filters:{type:Object,default(){ return {}}},
        order:{type:Array,default(){}},
        pageSize:{type:Number},
        loadWhenVisible:{type:Boolean},
    },
    data() {
        return {
            query:new ResourceQuery(this.action),
            paginator:null,
            error:null,
        };
    },
    computed: {
        items(){ return (this.paginator && this.paginator.data) || []; },
        loading(){ return !this.paginator || this.paginator.loading; },
        hasMore(){ return !this.paginator || this.paginator.hasMore(); },
    },
    methods: {
        initQuery(){
            console.log('initquery')
            this.query.filters = this.filters;
            this.query.order_by = this.order;
            this.query.pageSize = this.pageSize;
            //init paginator
            this.paginator = this.query.paginate(false);
            this.fetchMore();
        },
        fetchMore(){
            if(this.loading)
                return false;
            this.paginator.loadMore()
                .then(d=>{
                    console.log('fetched',d)
                    this.$emit('loaded');
                })
                .catch(e=>{
                    console.error('ERROR',e)
                    this.error = e;
                })
        },
        onIntersect(){
            if(this.loadWhenVisible && !this.loading)
                this.fetchMore();
        }
    },
    watch: {
        filters:{
            deep:true,
            handler(){this.initQuery()}
        },
        order:{
            deep:true,
            handler(){this.initQuery()}
        },
        pageSize:{
            deep:true,
            handler(){this.initQuery()}
        },
    },
    filters: {}
}
</script>
